/* eslint-disable import/prefer-default-export */

export const isSmartFilters = (title) => title === "Smart Filters";
